import React from 'react'
export const icon_def = {
    trash: { className: 'fal fa-trash' },
    plus: { className: 'fal fa-plus' },
    add: { className: 'fal fa-plus' },
    close: { className: 'fal fa-times' },
    warning: { className: 'fal fa-exclamation-triangle' },
    check: { className: 'fal fa-check' },
    click: { className: 'fal fa-mouse-pointer' },
    text: { className: 'fal fa-font' },
    link: { className: 'fal fa-link' },
    copy: { className: 'fal fa-copy' },
    loading: { className: 'fal fa-circle-notch fa-spin' },
    'log-out': { className: 'fal fa-power-off' },
    lock: { className: 'fal fa-lock' },
    'mouse-pointer': { className: 'fal fa-mouse-pointer' },
    desktop: { className: 'fal fa-desktop' },
    mobile: { className: 'fal fa-mobile' },
    tablet: { className: 'fal fa-tablet' },
    'product-selector': { className: 'fal fa-bullseye' },
    clock: { className: 'fal fa-clock' },
    home: { className: 'fal fa-home' },
    site: { className: 'fal fa-sitemap' },
    article: { className: 'fal fa-file' },
    amazon: { className: 'fab fa-amazon' },
    'angle-up': { className: 'fal fa-angle-up' },
    'angle-right': { className: 'fal fa-angle-right' },
    'angle-down': { className: 'fal fa-angle-down' },
    'angle-left': { className: 'fal fa-angle-left' },
    file: { className: 'fal fa-file-alt' },
    sort: { className: 'fal fa-sort-amount-down' },
    relevance: { className: 'fal fa-bullseye' },
    salesrank: { className: 'fal fa-award' },
    // 'salesrank': { className: 'fal fa-file-invoice-dollar' },
    price: { className: 'fal fa-sort-amount-up' },
    price_desc: { className: 'fal fa-sort-amount-down' },
    reviewrank: { className: 'fal fa-star' },
    reviewrank_authority: { className: 'fal fa-stars' },
    external: { className: 'fal fa-external-link-alt' },
    google: { className: 'fab fa-google' },
    sitemap: { className: 'fal fa-sitemap' },
    anchor: { className: 'fal fa-anchor' },
    bolt: { className: 'fal fa-bolt' },
    'angle-double-right': { className: 'fal fa-angle-double-right' },
}
export default class Icon extends React.PureComponent {
    render() {
        const { onClick } = this.props
        if (!icon_def[this.props.name]) {
            console.error('Invalid icon name "' + this.props.name + '"')
        }
        return (
            <span onClick={onClick || undefined} key={this.props.name}>
                <i className={`${icon_def[this.props.name]?.className} ${this.props.className || ''}`} />
            </span>
        )
    }
}
